export default "__VITE_ASSET__a_xax99J__"